import {useMutation} from "@apollo/client";
import {useState} from "react";
import toast from "react-hot-toast";
import {useNavigate} from "react-router";

import {DeleteActionDialog} from "@/components/deleteActionDialog/DeleteActionDialog.tsx";
import {DropdownItem} from "@/components/dropdown/subComponents/DropdownItem/DropdownItem.tsx";
import {GQL_USER_CONTEXT} from "@/lib/queries/accounts.ts";
import {GQL_DASHBOARD_DELETE} from "@/lib/queries/website.ts";
import {GraphQLResponse} from "@/lib/types/common.ts";
import {DashboardDefinition} from "@/lib/types/website.ts";

export const MenuItemDelete = ({dashboardDef}: {dashboardDef: DashboardDefinition}) => {
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [deleteDashboard] = useMutation<GraphQLResponse<null>>(GQL_DASHBOARD_DELETE, {
    refetchQueries: [GQL_USER_CONTEXT],
  });
  const navigate = useNavigate();

  return (
    <>
      <DropdownItem onClick={() => setShowDeleteConfirmation(true)} disabled={dashboardDef.id === 0}>
        Delete
      </DropdownItem>
      <DeleteActionDialog
        show={showDeleteConfirmation}
        title="Delete Dashboard"
        onCancel={() => setShowDeleteConfirmation(false)}
        onConfirm={async () => {
          await deleteDashboard({variables: {dashboard_id: dashboardDef.id}});
          setShowDeleteConfirmation(false);
          toast.success("Dashboard deleted");
          navigate("/dashboard/");
        }}
      >
        Are you sure you want to delete "{dashboardDef.name}"
      </DeleteActionDialog>
    </>
  );
};
